export default "__VITE_PUBLIC_ASSET__41aaebf2__"